/* istanbul ignore file */
import { useMemo } from 'react';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useIdentity } from '@zenbusiness/application-commons-identity';

import { getMenuConfig } from '../config';

/**
 * Return the menu config for the current business entity.
 *
 * @param {boolean} isMobile
 * @returns {{
 *  loading: boolean
 *  menu: Array
 * }}
 */
export function useBusinessEntityNav({ isMobile }) {
  const { accountEmail: email } = useIdentity();
  const { businessEntityUuid, entitlements, loading } = useBusinessEntity();

  // Need to memoize the ldFlags if we want to memoize the menu
  const ldFlags = useMemo(() => ({}), []);

  const menu = useMemo(
    () =>
      getMenuConfig({
        businessEntityUuid,
        email,
        entitlements,
        isMobile,
        ldFlags,
      }),
    [businessEntityUuid, email, entitlements, isMobile, ldFlags],
  );

  return { loading, menu };
}
